import { format } from 'date-fns';
import { addWorkDays, formatMonthName, formatYearMonthDayToDate, isSameMonth } from 'utils/dateUtils';

export const formatUpcomingDate = (dateString?: string): string | undefined => {
  if (!dateString) return undefined;

  try {
    const date = formatYearMonthDayToDate(dateString);
    if (!date || Number.isNaN(date.getTime())) return undefined;
    return format(date, 'MMMM d');
  } catch {
    return undefined;
  }
};

export const getMaxExpectedPayoffDate = (fundsSentDate: string | undefined): Date => {
  if (!fundsSentDate) return addWorkDays(new Date(), 5);
  return addWorkDays(new Date(fundsSentDate), 5);
};

export const getMinExpectedPayoffDate = (fundsSentDate: string | undefined): Date => {
  if (!fundsSentDate) return addWorkDays(new Date(), 3);
  return addWorkDays(new Date(fundsSentDate), 3);
};

export const getPayoffLabel = (fundsSentDate: string | undefined): string => {
  if (!fundsSentDate) return '3–5 business days after signing';

  const minEstimation = getMinExpectedPayoffDate(fundsSentDate);
  const maxEstimation = getMaxExpectedPayoffDate(fundsSentDate);

  if (isSameMonth(minEstimation, maxEstimation)) {
    return `${formatMonthName(minEstimation)} ${minEstimation.getDate()}–${maxEstimation.getDate()}`;
  }

  return `${formatMonthName(minEstimation, {
    month: 'short',
  })} ${minEstimation.getDate()}–${formatMonthName(maxEstimation, { month: 'short' })} ${maxEstimation.getDate()}`;
};
